import React, { useEffect } from 'react';
import { signupUser, userSelector, clearState } from '../features/User/UserSlice';

import { GoogleLogin, GoogleLogout } from 'react-google-login';
import { gapi } from 'gapi-script';
import { useSelector, useDispatch } from 'react-redux';
import { refreshTokenSetup } from '../utils/refreshToken';

const clientId = '458155414567-p503q8buhbgku64op2pmnm3r34ppqj64.apps.googleusercontent.com';



function LoginHooks() {
  const dispatch = useDispatch();
  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: clientId,
        scope: ''
      });
    };
    gapi.load('client:auth2', initClient);
  });
  const onSuccess = (res) => {
    // console.log('success:', res);
    // console.log('Login Success: currentUser:', res.profileObj);
    // console.log('Login Success: currentUser:', res.profileObj.email);
    // console.log('Login Success: currentUser:', res.profileObj.name);//googleId//givenName//imageUrl
    alert(
      `Logged in successfully welcome ${res.profileObj.name} 😍. \n See console for full profile object.`
    );
    var data = {"name": res.profileObj.name,"email":res.profileObj.email, "password":"pass@123"}
    dispatch(signupUser(data));
  };
  const onFailure = (err) => {
    //console.log('failed:', err);
  };
  const onLogoutSuccess = (res) => {
    //console.log('Logged out Successfully:', res);
    alert('Logged out Successfully ✌');
  }
  const onLogoutFailure = (err) => {
   // console.log('failed:', err);
  };
  return (
    <div>
      <GoogleLogin
        clientId={clientId}
        buttonText="Sign in with Google"
        onSuccess={onSuccess}
        onFailure={onFailure}
        cookiePolicy={'single_host_origin'}
        isSignedIn={true}
      />
      <GoogleLogout
        buttonText="Logout"
        onLogoutSuccess={onLogoutSuccess}
      >
      </GoogleLogout>
    </div>



  );
}

export default LoginHooks;